<div class="pb-2.5">
  <label class="block mb-2 border-b border-gray-300">{{ to.label }}</label>
  <div class="pl-2.5">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
